(() => {
  if (customElements.get('af50-product-price')) return;
  class AF50ProductPrice extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-af50-variants]').textContent);
      this.scope = this.closest('[data-section-type="product"]') || this.closest('.shopify-section');
      this.onVariant = (event) => {
        if (event.target !== this.scope && !event.target.contains(this)) return;
        const variant = event.detail?.variant;
        const prices = variant && this.variants.find((item) => String(item.id) === String(variant.id));
        this.hidden = !prices;
        if (prices) {
          this.querySelector('.AF50__Sale').textContent = prices.sale;
          this.querySelector('.AF50__Original').textContent = prices.original;
        }
      };
      this.scope?.addEventListener('variant:changed', this.onVariant);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('variant:changed', this.onVariant);
    }
  }
  customElements.define('af50-product-price', AF50ProductPrice);
})();
